import { createApi } from '@reduxjs/toolkit/query/react';
import type { CallRatingInput } from '../types';
import { ogBaseQuery } from '../../ogBaseQuery';

export const callRatingOGService = createApi({
  reducerPath: 'callRatingOGReducerFromLibrary',
  baseQuery: ogBaseQuery(),
  endpoints: (builder) => ({
    saveCallRating: builder.mutation<void, CallRatingInput>({
      query: (payload) => ({
        method: 'POST',
        url: `callRatings/save`,
        body: payload,
      }),
    }),
  }),
});

export const {
  endpoints: { saveCallRating },
} = callRatingOGService;
